import { memo } from 'react';

import { Description, Item, Label, RequiredSymbol } from '../../AddBeneficiaryPopup.styles';
import FieldInput from '../FieldInput/FieldInput';
import FieldSelect from '../FieldSelect/FieldSelect';
import { FieldWrapperProps } from './FieldWrapper.types';

const inputFieldTypes = ['INPUT'];
const selectFieldTypes = ['PAYMENT_METHOD', 'RADIO', 'SELECT'];

const FieldWrapper = memo<FieldWrapperProps>((props) => {
    const { field, formValues, setFormValues, setFieldsTouched, validationErrors, setValidationErrors } = props;

    return (
        <Item key={field.path}>
            <Label>
                {field.field.label}

                {field.required && <RequiredSymbol>&nbsp;*</RequiredSymbol>}
            </Label>

            {inputFieldTypes.includes(field.field.type) && (
                <FieldInput
                    field={field}
                    formValue={formValues[field.path]}
                    setFormValues={setFormValues}
                    setFieldsTouched={setFieldsTouched}
                    setValidationErrors={setValidationErrors}
                    validationErrors={validationErrors}
                />
            )}

            {selectFieldTypes.includes(field.field.type) && (
                <FieldSelect
                    field={field}
                    formValue={formValues[field.path]}
                    setFormValues={setFormValues}
                    setFieldsTouched={setFieldsTouched}
                />
            )}

            <Description>{field.field.description}</Description>
        </Item>
    );
});

export default FieldWrapper;
